"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNewsroomOgImageUrl = exports.getNewsroomFaviconUrl = exports.getNewsroomLogoUrl = void 0;
const uploadcare_1 = require("@prezly/uploadcare");
const constants_1 = require("./constants");
function getNewsroomLogoUrl(newsroom, previewSize) {
    if (newsroom.newsroom_logo) {
        const image = uploadcare_1.UploadcareImage.createFromPrezlyStoragePayload(newsroom.newsroom_logo);
        if (previewSize) {
            return image.preview(previewSize, previewSize).cdnUrl;
        }
        return image.cdnUrl;
    }
    return '';
}
exports.getNewsroomLogoUrl = getNewsroomLogoUrl;
function getNewsroomFaviconUrl(newsroom, previewSize = 400) {
    const imageObject = newsroom.icon || newsroom.square_logo;
    if (imageObject) {
        const image = uploadcare_1.UploadcareImage.createFromPrezlyStoragePayload(imageObject);
        return image.preview(previewSize, previewSize).cdnUrl;
    }
    return '';
}
exports.getNewsroomFaviconUrl = getNewsroomFaviconUrl;
function getNewsroomOgImageUrl(newsroom, locale) {
    return `${constants_1.OG_IMAGE_API_URL}/${newsroom.uuid}${locale ? `?locale=${locale.toUrlSlug()}` : ''}`;
}
exports.getNewsroomOgImageUrl = getNewsroomOgImageUrl;
//# sourceMappingURL=getNewsroomLogoUrl.js.map